import { render } from "./SpareTypes.vue?vue&type=template&id=bdc825be"
import script from "./SpareTypes.vue?vue&type=script&lang=js"
export * from "./SpareTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__